import { render, staticRenderFns } from "./clientCollectionLogout.vue?vue&type=template&id=da40669c&"
import script from "./clientCollectionLogout.vue?vue&type=script&lang=js&"
export * from "./clientCollectionLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports